import * as React from 'react';
import ReactDOM from 'react-dom';

import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility';

const DemoBlockedModal: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const { modalRef } = useModalAccessibility(onClose);
  {/* Rendered via portal to document.body so that position:fixed and z-index work correctly.
      Without this, a parent modal can create a new CSS stacking context that clips the backdrop
      and traps fixed-position children, causing the overlay to appear cropped or misaligned. */}
  return ReactDOM.createPortal(
    <div className="modal-container demo-blocked-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="demoBlockedModalTitle"
        aria-modal="true"
        className="demo-blocked-modal quill-modal"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div className="demo-blocked-modal-header">
          <h3 className="title" id="demoBlockedModalTitle">You are in a demo account</h3>
        </div>
        <div className="demo-blocked-modal-body modal-body">
          <p>The demo account is to show you what sample data looks like. As a result, editing is disabled in the demo account. To exit the demo account, please click the <strong>Exit demo account</strong> button in the upper right corner of the page.</p>
        </div>
        <div className="demo-blocked-modal-footer">
          <div className="buttons">
            <button
              className="quill-button contained medium green focus-on-light"
              onClick={onClose}
              type="button"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default DemoBlockedModal;
